// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ac73dae0","772":"27be4a2b","960":"4d0fab3f"}[chunkId] + ".chunk.js";
};